import { NavItems } from 'components/Header/components/Navigation/Navigation.helpers';

const navItems: NavItems[] = [
  {
    label: 'Home',
    path: '/',
    key: 'home',
    userTypes: [],
  },
  {
    label: 'Network Health',
    path: '/network-health',
    key: 'network-health',
    userTypes: [],
  },
  {
    label: 'Reports',
    path: '/reports',
    key: 'reports',
    userTypes: [],
  },
  {
    label: 'Users',
    path: '/users-summary/list',
    key: 'users-summary',
    userTypes: [],
  },
];

export { navItems };
